<template>
  <div class="login">
    <default-header />
    <v-main>
      <v-container fluid style="height: 74.5vh">
        <default-login-form />
      </v-container>
    </v-main>
    <default-footer />
  </div>
</template>

<script>
export default {
  name: "login",
  components: {
    "default-header": () => import("../../home/components/header/index.vue"),
    "default-footer": () => import("../../home/components/footer/index.vue"),
    "default-login-form": () => import("../components/login-form/index.vue"),
  },
};
</script>
